// eslint-disable-next-line @typescript-eslint/no-var-requires
const Slider = require("react-slick").default;

import { ExternalLink } from "~/components/site/external-link";
import { Settings } from "~/components/site/testimonials";

type Slides = Readonly<{
  image: string;
  alt: string;
  href?: string;
  title?: string;
}>;

type Props = Readonly<{
  slides: Slides[];
  settings: Settings;
}>;

export function ImageSlider({ slides, settings }: Props): JSX.Element {
  return (
    <Slider {...settings} className="images">
      {slides.map((slide) => (
        <div key={slide.image}>
          {slide.href ? (
            <ExternalLink href={slide.href} title={slide.title}>
              <img src={slide.image} alt={slide.alt} />
            </ExternalLink>
          ) : (
            <img src={slide.image} alt={slide.alt} />
          )}
        </div>
      ))}
    </Slider>
  );
}
